import parsePresetAttributes from '@/utils/file/parsePresetAttributes';
import type { AnalyticsSettings } from '@/types/analytics';
import type { ContentFileAttributes } from '@/types';

const getAnalyticsSettingsFromAttributes = (
  attributes?: ContentFileAttributes
): AnalyticsSettings => {
  const { slug, category } = parsePresetAttributes(attributes?.category);
  return { category: category ?? '', id: slug ?? '' };
};

export default getAnalyticsSettingsFromAttributes;
